<script>
import AddEditTask from '../../../orangehrmAdminPlugin/pages/task/AddEditTask.vue';
import Dialog from '@ohrm/oxd/core/components/Dialog/Dialog';
export default {
  components: {
    Dialog,
    AddEditTask,
  },
  data() {
    return {
      show: false,
      reject: null,
      resolve: null,
    };
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.show = true;
      });
    },
    onCancel() {
      this.show = false;
      this.resolve && this.reject('cancel');
    },

    afterSubmit(taskData) {
      this.show = false;
      this.resolve && this.resolve(taskData);
    },
  },
};
</script>
<template>
  <teleport to="#app">
    <Dialog
      v-if="show"
      style="max-width:1150px; width:100%"
      @update:show="onCancel"
    >
      <AddEditTask
        :is-modal="true"
        @onCancel="onCancel"
        @afterSubmit="afterSubmit"
      />
    </Dialog>
  </teleport>
</template>
<style src="./dialog.scss" lang="scss" scoped></style>
